import menu from "./menu";
import dashboard from "./dashboard";
import board from "./board";
import connections from "./connections";
import tickets from "./tickets";
import chat from "./chat";
import contacts from "./contacts";
import quickAnswers from "./quickAnswers";
import queues from "./queues";
import users from "./users";
import settings from "./settings";

// id do passo (steps.js) -> cena
export default {
	menu,
	dashboard,
	board,
	connections,
	tickets,
	chat,
	contacts,
	quickAnswers,
	queues,
	users,
	settings,
};
